import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2205aa02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formStep" }
const _hoisted_2 = { class: "stepItem" }
const _hoisted_3 = { class: "stepShow" }
const _hoisted_4 = { class: "stepIndex" }
const _hoisted_5 = { class: "stepStatus" }

import inActive from '@/assets/step-inactive.svg'
import Active from '@/assets/step-active.svg'
import Current from '@/assets/step-current.svg'
import { withDefaults } from 'vue'
import { Icon } from 'vant'
type StepData = {
  status: string
}
interface propsStep {
  stepData: Array<StepData>
  stepActive: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'header-step',
  props: {
    stepData: { default: () => [] },
    stepActive: { default: 1 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stepData, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "stepContent"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Icon), {
                name: 
                index === __props.stepActive - 1 ? _unref(Current) : index > __props.stepActive - 1 ? _unref(inActive) : _unref(Active)
              
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["stepName", { 'active-text': index <= __props.stepActive - 1 }])
              }, _toDisplayString(item.status), 3)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(__props.stepActive - 1 <= index ? 'stepLine' : 'stepActiveLine'),
          style: _normalizeStyle({
          width:
            index == __props.stepData.length - 1
              ? 0 + 'px'
              : `calc(calc(100% - 145px) / ${__props.stepData.length - 1})`,
          border: index == __props.stepData.length - 1 ? 'none' : '1px dashed rgba(0, 0, 0, 0.1);',
        })
        }, null, 6)
      ]))
    }), 128))
  ]))
}
}

})